import JSZip from 'jszip';
import downloadFile from './download-file';

export default async function downloadFiles(
  files: Array<{
    url: string;
    name: string;
  }>,
  fileName: string,
) {
  if (!files.length) {
    return;
  }

  const zip = new JSZip();

  await Promise.all(
    files.map(async (file) => {
      try {
        const response = await fetch(file.url);
        if (response.ok) {
          const blob = await response.blob();
          zip.file(file.name, blob);
        }
      } catch (error) {
        console.error(`Failed to download file: ${file.name}`, error);
      }
    }),
  );

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  downloadFile(zipBlob, fileName);
}
